<template>
  <div>
    <div class="top">
      报修详情
    </div>
    <ul>
      <li>
        <span class="title">报修单号：</span>
        <span class="content">{{ repair_orderId }}</span>
      </li>
      <li>
        <span class="title">申请时间：</span>
        <span class="content">{{ create_time }}</span>
      </li>
      <li>
        <span class="title">用户：</span>
        <span class="content">{{ name }}</span>
      </li>
      <li>
        <span class="title">产品名称：</span>
        <span class="content">{{ goods_name }}</span>
      </li>
    </ul>
    <div class="hr"></div>
    <div>
      <span class="title content-title">问题描述：</span>
      <div v-text="content" class="content-box"></div>
    </div>
    <ul>
      <li class="media">
        <div class="title">附图</div>
        <div class="content">
          <div v-if="voucher" v-for="(item, index) in voucher" :key="index" class="fl-l">
            <div v-if="item.type=='PIC'" :class="size=='big' ? 'layer' : null "><img :class="size" :src="item.path" @click="editSize"></div>
            <video class="tiny" v-else :src="item.path" @click="play"></video>
          </div>
        </div>
      </li>
      <li>
        <span class="title">联系人：</span>
        <span class="content">{{ nickname }}</span>
      </li>
      <li>
        <span class="title">联系方式：</span>
        <span class="content">{{ phone }}</span>
      </li>
      <li>
        <span class="title">详细地址：</span>
        <span class="content">{{ rep_address }}</span>
      </li>
      <li>
        <span class="title">备注：</span>
        <a-input class="input-a" placeholder="请输入您的备注！" v-model="remarkInfo" />
        <a-button type="primary" class="ml-20" @click="postEdit()">
          保存
        </a-button>
      </li>
    </ul>
    <a-popconfirm
      title="您确定要退出登录吗?"
      ok-text="是的"
      cancel-text="取消"
      @confirm="quit"
    >
      <a-button type="primary" href="#" class="butt-quit">退出登录</a-button>
    </a-popconfirm>
  </div>
</template>

<script>
import { getRepInfo } from '@/api/mobile/repair'
import { remark } from '@/api/repair'
import { logout } from '@/api/account'

export default {
  name: 'RepairManage',
  components: {},
  data () {
    return {
      id: '',
      repair_orderId: '',
      create_time: '',
      name: '',
      goods_name: '',
      nickname: '',
      phone: '',
      rep_address: '',
      content: '',
      voucher: [],
      remarkInfo: '',
      imgList: [],
      size: 'tiny'
    }
  },
  created() {
    this.getInfo()
  },
  methods: {
    // 获取数据
    getInfo() {
      this.id = this.$route.query && this.$route.query.id ? this.$route.query.id : ''
      getRepInfo({
        id: this.id
      })
        .then((res) => {
          if (res.code === 200) {
            this.repair_orderId = res.data.repair_orderId
            this.create_time = res.data.create_time
            this.name = res.data.name
            this.goods_name = res.data.goods_name
            this.nickname = res.data.nickname
            this.phone = res.data.phone
            this.rep_address = res.data.rep_address
            this.content = res.data.content
            this.voucher = res.data.voucher
            this.remarkInfo = res.data.remark
            for (let i = 0; i < this.voucher.length; i++) {
              this.imgList[i] = this.voucher[i].path
            }
          }
        })
        .catch((e) => {
          this.$message.error('请求预加载接口失败')
        })
    },
    // 保存备注
    postEdit() {
      var data = {}
      data.remark = this.remarkInfo
      data.repair_order_id = window.location.search.substring(4)
      remark(data)
        .then((res) => {
          if (res.code === 200) {
            this.$message.success('备注成功')
          }
        })
        .catch((e) => {
          this.$message.error('备注失败')
        })
    },
    // 点击全屏播放
    play(e) {
      e.target.requestFullscreen()
      e.target.play()
    },
    editSize() {
      if (this.size === 'tiny') {
        this.size = 'big'
      } else {
        this.size = 'tiny'
      }
    },
    quit() {
      logout().then(() => {
        var par = window.location.search.substring(4)
        this.$router.push({ path: '/merchant/login', query: { id: par } })
      })
    }
  }
}
</script>
<style>
body{
  background-color: #fff;
  color: #000;
  font-size: 16px;
}
ul{
  list-style: none;
  padding: 1rem 0 0 1rem;
  position: relative;
}
ul li{
  height: 3rem;
  line-height: 3rem;
}
.title{
  color: #777777;
}
.content{
  position: absolute;
  left: 30%;
}
.top{
  height: 42px;
  font-size: 20px;
  background-color: #EDEDED;
  text-align: center;
  padding: 6px;
}
.hr{
  height: 1rem;
  background-color: #F2F2F2;
  width: 100%;
}
.content-box{
  width: 90%;
  height: auto;
  background-color: #F2F2F2;
  margin: 1rem 0 0 1rem;
  padding: 1rem;
  border-radius: 10px;
  border: 1px solid #A6A6A6;
}
.content-title{
  margin: 1rem 0 0 1rem;
  display: block;
}
.input-a{
  margin-left: 10%;
  width: 40%;
  background-color: #F2F2F2;
  border-color: #B0B0B0;
  color: #000;
}
.media{
  margin: 1.3rem 0;
  display: flex;
}
.fl-l{
  float: left;
  margin-right: 1rem;
}
.tiny{
  width: 4rem;
  height: 4rem;
  border-radius: 5px;
}
.big{
  width: 100%;
  align-self: center;
}
.layer{
   width: 100%;
   height: 100vh;
   position: fixed;
   left: 0;
   top: 0;
   background: rgba(0,0,0,0.5);
   z-index: 9999;
   display: grid;
 }
.butt-quit{
  width: 80%;
  margin: 0 0 10% 10%;
}
</style>
